/**
 * 域名白名单
 */
export const whiteList = [
  'blob:',
  'wxaurl.cn',
  '.sina.com.cn',
  '.163.com',
  '.baidu.com',
  '.qq.com',
  '.weibo.com',
  '.sohu.com',
  'eteams.cn',
  '.teems.cn',
  '.yunteams.cn',
  '.mulinquan.com',
  '.mulinquan.cn',
  '.teamsyun.com',
  '.teamsyun.cn',
  '.develop.cn',
  '.e-biaoge.cn',
  'e-biaoge.cn',
  '.ebiaoge.com',
  '.tianyancha.com',
  '.qiyuesuo.com',
  '.qiyuesuo.cn',
  '.beian.gov.cn',
  '.weaver.com.cn',
  'eteams.oss.aliyuncs.com',
  'eteamsbeta.oss.aliyuncs.com',
  'newoa.teamscloud.cn',
  'andfx.net',
  'mypiaojia.com',
  'beian.miit.gov.cn',
];

class WhiteListSdk {
  whiteList: string[] = [];

  addWhiteList = (addWhiteList: string[] | string) => {
    if (Array.isArray(addWhiteList)) {
      this.whiteList = [...this.whiteList, ...addWhiteList];
    } else {
      this.whiteList.push(addWhiteList);
    }
  };

  updateWhiteList = (updateWhiteList: string[] | string) => {
    if (Array.isArray(updateWhiteList)) {
      this.whiteList = updateWhiteList;
    } else {
      this.whiteList = [updateWhiteList];
    }
  };
}

const whiteListSdk = new WhiteListSdk();

export { whiteListSdk };
